import type { HTMLAttributes } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/cn';

const badgeVariants = cva(
  'inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-medium leading-none ring-1 ring-inset',
  {
    variants: {
      tone: {
        neutral: 'bg-muted text-foreground ring-border',
        primary: 'bg-primary/10 text-primary ring-primary/30',
        success: 'bg-success/10 text-success ring-success/30',
        warning: 'bg-warning/10 text-warning-soft ring-warning/30',
        danger: 'bg-danger/10 text-danger ring-danger/30',
        info: 'bg-info/10 text-info ring-info/30',
      },
    },
    defaultVariants: { tone: 'neutral' },
  },
);

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement>, VariantProps<typeof badgeVariants> {}

export function Badge({ className, tone, ...rest }: BadgeProps) {
  return <span className={cn(badgeVariants({ tone }), className)} {...rest} />;
}
